import qs from "qs";

import CapacityChangeApi from "../../services/api/CapacityChange";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getPath, isValNull, removeEmptyVals } from "../../utils";
import SuccessMessages from "../../constants/SucessMessages.json";
import SlotsPropertiesApi from "../../services/api/Slots";
import Errors from "../../constants/Errors.json";
import * as UserActions from "./User";
import { resetStateSlot } from "./Slots";

function handleError(err) {
  console.log("error in capacity change actions:", err);
}

const setCapacityChangeRequestData = (payload) => {
  return {
    type: ActionTypes.SET_CAPACITY_CHANGE_REQUESTS,
    payload,
  };
};

const setUserAttributes = (payload) => {
  return {
    type: ActionTypes.SET_CAPACITY_CHANGE_ATTRIBUTES,
    payload,
  };
};

export const resetCapacityState = (payload) => {
  return {
    type: ActionTypes.RESET_CAPACITY_CHANGE_STORE,
    payload,
  };
};

export const setEntityList = (payload) => {
  return {
    type: ActionTypes.SET_ENTITY_LIST_CAPACITY_CHANGE,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_CAPACITY_CHANGE,
    payload,
  };
};

export const getCapacityChangeRequestData =
  (payload, pageRequest) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let requestData = {};
      removeEmptyVals(payload);
      if (!isValNull(payload.request_id)) {
        requestData = { request_id: parseInt(payload.request_id) };
      } else {
        requestData = {
          entity_type: payload?.entity_type,
          entity_ids: payload?.entity_ids,
          carrier_types: payload?.carrier_types,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          status: payload?.status,
          sort_order: payload?.sort_order,
        };
      }
      pageRequest = { ...pageRequest, pageSize: 50 };
      const newState = removeEmptyVals(requestData);
      const response = await CapacityChangeApi.getCapacityChangeRequestData({
        filters: newState,
        pageRequest,
      });
      dispatch(setLoader(false));
      if (response) {
        dispatch(setCapacityChangeRequestData(response));
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.LIST_RETRIEVAL_SUCCESS,
          })
        );
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getCapacityChangeUserAttributes = (action) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let userAttributeQuery = {
      action,
    };
    const response = await CapacityChangeApi.getUserAttributes(
      new URLSearchParams(userAttributeQuery).toString()
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(setUserAttributes(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createCapacityChangeRequest =
  (payload, entityId) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      const request = {
        capacity_change_requests: payload,
      };
      const queryParams = {
        attribute_type: "ZONE_ID",
        attribute_value: entityId,
      };
      const response = await CapacityChangeApi.createCapacityChangeRequest(
        request,
        new URLSearchParams(queryParams).toString()
      );
      dispatch(setLoader(false));
      if (response?.status) {
        dispatch(resetStateSlot({ state: "slotsList" }));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        UserActions.setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const updateCapacityChangeRequest = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const queryParams = {
      attribute_type: "ZONE_ID",
      attribute_value: payload?.entity_id,
    };
    const response = await CapacityChangeApi.updateCapacityChangeRequest(
      payload,
      new URLSearchParams(queryParams).toString()
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(resetCapacityState({ state: "capacityChangeRequests" }));
      dispatch(
        UserActions.setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
    } else {
      UserActions.setStatus({ type: "error", message: Errors.GENERAL_ERROR });
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      UserActions.setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
